(() => {
  document.addEventListener('DOMContentLoaded', () => {
    window.setTimeout(() => {
      document.documentElement.classList.add('unlock-aria-hidden-animations');
    }, 2000);
  });
})();
